export default "__VITE_ASSET__3a054bf6__"